<template>
  <div class="auth-field">
    <label class="auth-field__label" :for="id">{{ label }}</label>

    <div class="auth-field__control">
      <component :is="icon" class="auth-field__icon" :size="20" aria-hidden="true" />

      <input
        :id="id"
        ref="inputElement"
        class="auth-field__input"
        :type="type"
        :value="modelValue"
        v-bind="$attrs"
        @input="onInput"
      />

      <slot name="trailing" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, useAttrs, type Component } from "vue";

defineOptions({ inheritAttrs: false });

const attrs = useAttrs();
const inputElement = ref<HTMLInputElement | null>(null);

onMounted(() => {
  if (attrs.autofocus !== undefined && attrs.autofocus !== false) {
    inputElement.value?.focus();
  }
});

withDefaults(
  defineProps<{
    id: string;
    label: string;
    icon: Component;
    modelValue: string;
    type?: string;
  }>(),
  {
    type: "text",
  },
);

const emit = defineEmits<{
  "update:modelValue": [value: string];
}>();

const onInput = (event: Event): void => {
  emit("update:modelValue", (event.target as HTMLInputElement).value);
};
</script>
